import { authFetch, BASE_BACKEND_URL } from '../../auth'
import React, { useState, useEffect } from 'react'
import AsyncSelect from 'react-select/async'
import axios from 'axios'
import _ from 'lodash'
import { fixDateString, getDay, getMonth } from '../../helpers/formatDate'
import { replaceAccentedCharacters, generateUUID } from '../../helpers/utils'
import {
  FormControl,
  Select,
  MenuItem,
  InputLabel
} from '@mui/material'
import TaskDescription from './components/TaskDescription'
import TaskClientOrAttribute from './components/TaskClientOrAttribute'
import { useTaskAttributeQualifiers } from './components/TaskAttributeHelper'
import TaskScheduleConfig from './components/TaskScheduleConfig'
import {
  getTaskSchedulePayloadForCollect,
  isTaskFormSubmittable
} from './utils/posTaskSchedule'
import {
  getValidPackages,
  getPackageDisplayValue,
  getPackageColumns,
  getAvailablePackages
} from './components/packageHelper'
import { TextField, Button } from '@mui/material'
import GoogleIcon from '../../icon/GoogleIcon'

const normalizeCompetitionProducts = (competitionProducts) => {
  if (Array.isArray(competitionProducts)) {
    return competitionProducts
  }

  if (typeof competitionProducts === 'string') {
    try {
      const parsedCompetitionProducts = JSON.parse(competitionProducts)
      return Array.isArray(parsedCompetitionProducts) ? parsedCompetitionProducts : []
    } catch (error) {
      return []
    }
  }

  return []
}

const PriceCaptureTask = ({
  setCloningTask,
  cloningTask,
  setFailedCreation,
  failedCreation,
  taskData,
  readyToCollect,
  setSaving,
  setReadyToCollect,
  formDataCollector,
  setShowProductAlert,
  isStep3Completed,
  setIsStep3Completed
}) => {
  const [description, setDescription] = useState('')
  const [clientOrAttribute, setClientOrAttribute] = useState('')
  const [clients, setClients] = useState([])
  const [products, setProducts] = useState([])
  const [productSelection, setProductSelection] = useState('')
  const {
    qualifiers,
    setQualifiers,
    selectedQualifiers,
    qualifierOptions,
    handleChangeQualifier,
    resetSelectedQualifiers,
    isSomeQualifierSelected,
    validateAtLeastOneQualifier,
    getCollectDataQualifierFields,
    applyClonedTaskQualifiers
  } = useTaskAttributeQualifiers()
  const [users, setUsers] = useState([])
  const [userOptions, setUserOptions] = useState(null)
  const [userFilterChecked, setUserFilterChecked] = useState(false)
  const [isMandatoryTask, setIsMandatoryTask] = useState(false)
  const [productsBase, setProductsBase] = useState({})
  const [unitOfSale, setUnitOfSale] = useState('')
  const [prodName, setProdName] = useState('')
  const [prodPck, setProdPck] = useState('')
  const [competitionProducts, setCompetitionProducts] = useState([])
  const [prodNameError, setProdNameError] = useState('')
  const [prodPckError, setProdPckError] = useState('')
  const [openSelector, setOpenSelector] = useState('')
  const [newStartTime, setNewStartTime] = useState(null)
  const [newEndTime, setNewEndTime] = useState(null)
  const [schedulePayload, setSchedulePayload] = useState(null)
  const [showMandatoryConflict, setShowMandatoryConflict] = useState(false)
  const packageColumns = getPackageColumns(products)
  const availablePackages = getAvailablePackages(products)

  ////// Stops fetchs when page is changed
  const abortController = new AbortController()
  var abortClientController = new AbortController()
  var abortProductController = new AbortController()
  const abortCurrentFetchs = () => {
    abortClientController.abort('Fetch Aborted by User.')
    abortProductController.abort('Fetch Aborted by User.')
    abortController.abort('Fetch Aborted by User.')
  }
  window.addEventListener('beforeunload', abortCurrentFetchs)
  //////

  // Stops client fetch when is unfocus
  const abortClientFetchs = () => {
    abortClientController.abort('Fetch Aborted by User.')
  }
  //

  // Stops products fetch when is unfocus
  const abortProductFetchs = () => {
    abortProductController.abort('Fetch Aborted by User.')
  }
  //

  const handleStartTimeChange = (newStartTime) => {
    setNewStartTime(newStartTime)
  }

  const handleEndTimeChange = (newEndTime) => {
    setNewEndTime(newEndTime)
  }

  const handleMandatoryConflict = () => {
    setIsMandatoryTask(false)
    setShowMandatoryConflict(true)
  }

  const handleDismissMandatoryConflict = () => {
    setShowMandatoryConflict(false)
  }

  const handleProdNameChange = (event) => {
    setProdName(event.target.value)
    if (event.target.value.trim()) {
      setProdNameError('')
    }
  }

  const handleProdPckChange = (event) => {
    setProdPck(event.target.value)
    if (event.target.value.trim()) {
      setProdPckError('')
    }
  }

  const handleAddCompetitionProduct = (event) => {
    event.preventDefault()

    const trimmedProdName = prodName.trim()
    const trimmedProdPck = prodPck.trim()

    setProdNameError('')
    setProdPckError('')

    if (!trimmedProdName) {
      setProdNameError('Ingrese el nombre del producto.')
    }

    if (!trimmedProdPck) {
      setProdPckError('Ingrese la unidad de venta.')
    }

    if (trimmedProdName && trimmedProdPck) {
      setCompetitionProducts((competitionProducts) => [
        ...competitionProducts,
        { uid: generateUUID(), name: trimmedProdName, package: trimmedProdPck }
      ])
      resetCompetitionProductInputs()
    }
  }

  const resetCompetitionProductInputs = () => {
    setProdName('')
    setProdPck('')
  }

  const isAnyKindOfProductSelected = () => {
    return products?.length > 0 ? true : false
  }

  const isClientOrSomeQualifierSelected = () => {
    return clients?.length > 0 || isSomeQualifierSelected()
  }
  const handleMenuOpen = (selectorName) => {
    setOpenSelector(selectorName)
  }

  const handleMenuClose = () => {
    setOpenSelector('')
  }

  const handleClientOrAttributeChange = (event) => {
    setClientOrAttribute(event.target.value)
    setClients([])
    resetSelectedQualifiers()
    setUserFilterChecked(false)
    setUsers([])
  }

  const handleUnitOfSaleChange = (event) => {
    setUnitOfSale(event.target.value)
  }

  const getClient = async (inputValue) => {
    if (inputValue.length >= 3) {
      abortClientController = new AbortController()
      return authFetch(
        `${BASE_BACKEND_URL}/clients?q=${inputValue}&active=true`,
        {
          method: 'GET',
          signal: abortClientController.signal,
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
          }
        }
      )
        .then((response) => {
        if (!response) return
        return response.json()
      })
        .then((data) =>
          data.table.map((cl) => ({
            value: cl.name,
            label: `${cl.name} - ${cl.db_ref}`,
            client: cl
          }))
        )
        .catch((error) => {
          if (error !== 'Fetch Aborted by User.') {
            console.error('Error fetching clients:', error)
            return []
          }
        })
    }
  }

  const getQualifiers = () => {
    const url = `${BASE_BACKEND_URL}/promo_qualifiers`

    authFetch(url, {
      method: 'GET',
      signal: abortController.signal,
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      }
    })
      .then((response) => {
        if (!response) return
        return response.json()
      })
      .then((data) => {
        setQualifiers(data.result[0])
      })
      .catch((error) => {
        if (error !== 'Fetch Aborted by User.') {
          console.error('Error:', error)
        }
      })
  }

  const getUsers = () => {
    authFetch(
      `${BASE_BACKEND_URL}/ubiqua_app_users?non_paginated=true`,
      {
        method: 'GET',
        signal: abortController.signal,
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        }
      }
    )
      .then((response) => {
        if (!response) return
        return response.json()
      })
      .then((data) => {
        setUserOptions(
          data.table.map((u) => ({
            value: u.full_name,
            label: `${u.full_name} - ${u.uid}`,
            user: u
          }))
        )
      })
      .catch((error) => {
        if (error !== 'Fetch Aborted by User.') {
          console.error('Error:', error)
        }
      })
  }

  const getUserForCloning = async (uid) => {
    return authFetch(
      `${BASE_BACKEND_URL}/ubiqua_app_users/${uid}?active=true`,
      {
        method: 'GET',
        signal: abortController.signal,
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        }
      }
    )
      .then((response) => {
        if (!response) return
        return response.json()
      })
      .then((data) => {
        return {
          value: data.full_name,
          label: `${data.full_name} - ${data.uid}`,
          user: data
        }
      })
      .catch((error) => {
        if (error !== 'Fetch Aborted by User.') {
          console.error('Error:', error)
        }
      })
  }

  const getProductsBaseData = () => {
    authFetch(`${BASE_BACKEND_URL}/products/promo_necessary_data`, {
      method: 'GET',
      signal: abortController.signal,
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      }
    })
      .then((response) => {
        if (!response) return
        return response.json()
      })
      .then((data) => {
        setProductsBase(data)
      })
      .catch((error) => {
        if (error !== 'Fetch Aborted by User.') {
          console.error('Error:', error)
        }
      })
  }

  const getProducts = async (inputValue) => {
    if (inputValue.length >= 3) {
      abortProductController = new AbortController()
      return authFetch(
        `${BASE_BACKEND_URL}/products?q=${replaceAccentedCharacters(
          inputValue
        )}&productactive=true`,
        {
          method: 'GET',
          signal: abortProductController.signal,
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
          }
        }
      )
        .then((response) => {
          if (!response.ok) {
            throw new Error('Network response was not ok')
          }
          return response.json()
        })
        .then((data) => {
          const lookup = _.keyBy(products, (p) => p.db_ref)
          return data.table
            .filter((d) => !lookup[d.db_ref])
            .map((p) => ({
              value: p.name,
              label: `${p.name} - ${p.db_ref}`,
              product: p
            }))
        })
        .catch((error) => {
          if (error !== 'Fetch Aborted by User.') {
            console.error('Error:', error)
          }
        })
    }
  }

  const handleClientOption = (options) => {
    setClients(options)
  }

  const handleUsersChange = (options) => {
    setUsers(options)
  }

  const handleProductOption = (options) => {
    if (!options?.product) {
      return
    }
    if (products.find((e) => e.id === options.product.id)) {
      return
    }
    setProducts([...products, options.product])
  }

  const sleepWaitResponse = (ms) =>
    // eslint-disable-next-line no-undef
    new Promise((resolve) => {
      setTimeout(() => {
        resolve()
      }, ms)
    })

  const getTaskQuantity = () => {
    let taskQuantity = 0
    if (products?.length > 0) {
      taskQuantity += products.length
    }
    if (competitionProducts?.length > 0) {
      taskQuantity += competitionProducts.length
    }
    return taskQuantity
  }

  const collectData = () => {
    const scheduleResult = getTaskSchedulePayloadForCollect({
      startDate: newStartTime,
      schedulePayload
    })
    if (!scheduleResult.ok) {
      setFailedCreation(scheduleResult.message)
      setReadyToCollect(false)
      setTimeout(() => setFailedCreation(false), 15000)
      return
    }

    const recurrencePayload = scheduleResult.payload
    let jsonData = {
      description: description,
      completion_mode: recurrencePayload.completion_mode,
      recurrence_format: recurrencePayload.recurrence_format,
      recurrence_interval: recurrencePayload.recurrence_interval,
      recurrence_description: recurrencePayload.recurrence_description,
      start_date: fixDateString(newStartTime),
      end_date: fixDateString(newEndTime),
      qualifier_1: clients.map((c) => c.client.db_ref).sort(),
      ...getCollectDataQualifierFields(),
      user_uids: userFilterChecked ? users.map((u) => u.user.uid).sort() : [],
      user_names: userFilterChecked ? users.map((u) => u.label).sort() : [],
      is_mandatory_task: isMandatoryTask,
      products_db_ref: products.map((p) => p.db_ref).sort(),
      product_names: products.map((p) => p.db_ref + ' ' + p.name).sort(),
      unit_of_sale: unitOfSale,
      task_quantity: getTaskQuantity(),
      competition_products: competitionProducts
    }
    formDataCollector(jsonData)
  }

  const setUpTask = async () => {
    if (taskData) {
      try {
        setCloningTask(true)
        setDescription(taskData.description)

        if (taskData.client_names?.length > 0) {
          setClientOrAttribute('client')
          let _clients = []
          for (const clientName of taskData.qualifier_1) {
            let c = await getClient(clientName)
            if (c?.length > 0) {
              _clients.push(c[0])
            }
          }
          setClients(_clients)
        } else {
          setClientOrAttribute('qualifier')
          applyClonedTaskQualifiers(taskData)
        }

        if (taskData.is_mandatory_task) {
          setIsMandatoryTask(true)
        }

        if (taskData.user_uids?.length > 0) {
          let _users = []
          for (const uid of taskData.user_uids) {
            let user = await getUserForCloning(uid)
            if (user) {
              _users.push(user)
            }
          }
          setUsers(_users)
          setUserFilterChecked(true)
        }
      } catch (e) {
        console.log('Error en duplicacion de tarea  (Clientes/Atributos/Usuarios): ', e)
        setFailedCreation(
          'Hubo un error al intentar obtener: Los clientes o atributos o usuarios, requeridos para crear la copia de la tarea. Por favor, asegúrese de completar todos los campos faltantes en adelante.'
        )
        setTimeout(() => setFailedCreation(false), 15000)
        return setCloningTask(false)
      }
      try {
        let _products = []
        for (const productDbRef of taskData.products_db_ref) {
          let p = await getProducts(productDbRef)
          if (p?.length > 0) {
            _products.push(p[0]?.product)
          }
        }
        let cleanProducts = _products.filter(
          (value, index, self) => index === self.findIndex((t) => t.db_ref === value.db_ref)
        )
        setProducts(cleanProducts)

        setUnitOfSale(taskData.unit_of_sale)
        setCompetitionProducts(normalizeCompetitionProducts(taskData.competition_products))
      } catch (e) {
        console.log('Error en duplicacion de tarea  (Los productos propios o de competencia): ', e)
        setFailedCreation(
          'Hubo un error al intentar obtener: Los productos propios o de competencia, requeridos para crear la copia de la tarea. Por favor, asegúrese de completar todos los campos faltantes en adelante.'
        )
        setTimeout(() => setFailedCreation(false), 15000)
        return setCloningTask(false)
      }
      setCloningTask(false)
      await sleepWaitResponse(1000)
      setSaving(false)
    }
  }

  const validateProductSelection = () => {
    if (products.length === 0 && competitionProducts.length === 0) {
      setShowProductAlert(true)
      return false
    }
    setShowProductAlert(false)
    return true
  }

  useEffect(() => {
    setIsStep3Completed(
      isTaskFormSubmittable({
        startDate: newStartTime,
        schedulePayload,
        isBaseComplete: clients.length > 0 || isSomeQualifierSelected()
      })
    )
  }, [clients, selectedQualifiers, isSomeQualifierSelected, newStartTime, schedulePayload])

  useEffect(() => {
    getQualifiers()
    getUsers()
    getProductsBaseData()
  }, [])

  useEffect(() => {
    if (taskData) {
      setUpTask()
    }
  }, [taskData])

  useEffect(() => {
    if (readyToCollect) {
      if (!validateProductSelection()) {
        setShowProductAlert(true)
        setSaving(false)
        setReadyToCollect(false)
      } else {
        collectData()
      }
    }
  }, [readyToCollect])

  const isStep5Enabled = products.length > 0 || competitionProducts.length > 0

  if (cloningTask) {
    return null
  }
  return (
    <>
      <TaskDescription initialDescription={description} onDescriptionChange={setDescription} />

      <TaskClientOrAttribute
        clientOrAttribute={clientOrAttribute}
        handleClientOrAttributeChange={handleClientOrAttributeChange}
        clients={clients}
        handleClientOption={handleClientOption}
        abortClientFetchs={abortClientFetchs}
        getClient={getClient}
        selectedQualifiers={selectedQualifiers}
        qualifierOptions={qualifierOptions}
        onQualifierChange={handleChangeQualifier}
        validateAtLeastOneQualifier={() => validateAtLeastOneQualifier(selectedQualifiers)}
        description={description}
        isClientOrSomeQualifierSelected={isClientOrSomeQualifierSelected}
        userFilterChecked={userFilterChecked}
        setUserFilterChecked={setUserFilterChecked}
        isMandatoryTask={isMandatoryTask}
        setIsMandatoryTask={setIsMandatoryTask}
        recurrenceType={schedulePayload?.completion_mode}
        onMandatoryBlocked={handleMandatoryConflict}
        showMandatoryConflict={showMandatoryConflict}
        onDismissMandatoryConflict={handleDismissMandatoryConflict}
        users={users}
        userOptions={userOptions}
        handleUsersChange={handleUsersChange}
      />

      <div className="task-form-section">
        <div className="title-promos-form">
          <b class="bold-step">
            PASO 4: Escoja los productos (propios y/o de competencia) que aplican a esta tarea
          </b>
        </div>
        <p className="b-text-price">
          <span className="b-text-bold">Nota:</span> Asegúrese de incluir al menos un producto
          propio o uno de la competencia para continuar.
        </p>
        <hr className="hr-task-form-price" />
      </div>

      <div className="task-form-section step4">
        <div className="title-promos-form">
          <p>
            <b>
              <span style={{ fontStyle: 'italic' }}>Opcional</span> - PASO 4.1: Escoja los
              producto(s) propio(s) que aplican para esta tarea
            </b>
          </p>
        </div>
        <div className="task-form-control-width">
          <div
            className="fake-validator-container"
            style={{ zIndex: openSelector === 'product' ? 5000 : 1 }}
          >
            <input
              className={`input-fake-validator ${!isClientOrSomeQualifierSelected() && 'inactive'}`}
              type="text"
              value={products.length >= 1 ? products : null}
              disabled={!isClientOrSomeQualifierSelected()}
            />
            <AsyncSelect
              className={`clients ${!isClientOrSomeQualifierSelected() && 'inactive'} `}
              placeholder={'Escribir nombre o código del producto'}
              noOptionsMessage={() => 'No hay resultados'}
              loadingMessage={() => 'Cargando productos...'}
              name="selectOptionProducts"
              disabled={!isClientOrSomeQualifierSelected()}
              loadOptions={getProducts}
              isClearable={true}
              searchParamName={'q'}
              isSearchable={true}
              value={[]}
              onChange={(e, am) => {
                handleProductOption(e)
                am.action = 'clear'
              }}
              onMenuOpen={() => handleMenuOpen('product')}
              onMenuClose={handleMenuClose}
              onBlur={abortProductFetchs}
            />
          </div>
        </div>
        {products?.length > 0 && (
          <div className="row">
            <table className="table-pdv table-hover task-product-table">
              <thead className="table-header-gray-task">
                  <tr>
                    <th className="pl-20">CÓDIGO</th>
                    <th>NOMBRE DEL PRODUCTO</th>
                    {packageColumns.map((column) => (
                      <th key={column.label}>{column.label}</th>
                    ))}
                    <th className="centered">ACCIÓN</th>
                  </tr>
              </thead>
              <tbody>
                {products.map((product, index) => (
                  <tr key={`${product.id}-${index}`}>
                    <td className="pl-20">{product.db_ref}</td>
                    <td>{product.name}</td>
                    {packageColumns.map((column) => {
                      const productPackages = getValidPackages(product)

                      return <td key={`${product.id}-${column.label}`}>{getPackageDisplayValue(productPackages[column.index])}</td>
                    })}
                    <td
                      className="delete-selected-product"
                      onClick={(e) => setProducts(products.filter((p) => p.id !== product.id))}
                    >
                      &times;
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
      <div className="task-form-section" />
      <>
        <p className="title-promos-form">
          <b>PASO 4.2: Seleccione la unidad de venta de los productos propios</b>
        </p>
        <FormControl
          fullWidth
          required={products?.length > 0}
          size="small"
          sx={{
            pointerEvents: !isAnyKindOfProductSelected() ? 'none' : 'auto',
            opacity: !isAnyKindOfProductSelected() ? 0.6 : 1,
            backgroundColor: !isAnyKindOfProductSelected()
              ? '#f0f0f0'
              : 'transparent'
          }}
          className={`task-form-control-width ${!isAnyKindOfProductSelected() ? 'inactive' : ''
            }`}
        >
          <InputLabel id="unit-of-sale-label">
            Unidad de Venta
          </InputLabel>

          <Select
            labelId="unit-of-sale-label"
            name="base_package_promo"
            value={unitOfSale || ''}
            onChange={(e) => {
              if (!isAnyKindOfProductSelected()) return
              handleUnitOfSaleChange(e)
            }}
            label="Unidad de Venta"
            displayEmpty
          >
            {availablePackages.map((unitNumber) => (
              <MenuItem key={unitNumber} value={`unit_of_sale_${unitNumber}`}>
                {`Unidad de venta ${unitNumber}`}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </>
      <div className="mb-30" />
      <p className="title-promos-form">
        <b>
          <span style={{ fontStyle: 'italic' }}>Opcional</span> - PASO 4.3: Agregue los productos de
          competencia que aplican a esta tarea
        </b>
      </p>

      <div className="row">
        <div className="form-control-prod-name-width col-sm-1">
          <TextField
            type="text"
            inputProps={{ maxLength: 40 }}
            id="competitor-prod-name"
            name="competitor-prod-name"
            placeholder="Nombre del producto"
            value={prodName}
            onChange={handleProdNameChange}
            disabled={!isClientOrSomeQualifierSelected()}
            variant="outlined"
            size="small"
            fullWidth
            className={`form-control ${!isClientOrSomeQualifierSelected() && 'inactive'}`}
          />

          {prodNameError && (
            <p className="error-message">{prodNameError}</p>
          )}

          {!prodNameError && (
            <p className="small text-muted mt-10 pull-right font-size-prod">
              Cantidad máxima de caracteres {Math.abs(prodName.length - 40)}/40
            </p>
          )}
        </div>

        <div className="form-control-prod-pck-width col-sm-1">
          <TextField
            type="text"
            inputProps={{ maxLength: 20 }}
            id="competitor-prod-pck"
            name="competitor-prod-pck"
            placeholder="Unidad de venta"
            value={prodPck}
            onChange={handleProdPckChange}
            disabled={!isClientOrSomeQualifierSelected()}
            required={prodName.length > 0}
            variant="outlined"
            size="small"
            fullWidth
            className={`form-control ${!isClientOrSomeQualifierSelected() && 'inactive'}`}
          />

          {prodPckError && (
            <p className="error-message">{prodPckError}</p>
          )}

          {!prodPckError && (
            <p className="small text-muted mt-10 pull-right font-size-prod">
              Cantidad máxima de caracteres {Math.abs(prodPck.length - 20)}/20
            </p>
          )}
        </div>

        <div
          className="form-control-prod-btm-width col-sm-1"
        >
          <Button
            type="submit"
            onClick={handleAddCompetitionProduct}
            disabled={!isClientOrSomeQualifierSelected()}
            className={`btn-price-capture col-sm-1 ${!isClientOrSomeQualifierSelected() && 'inactive'}`}
            variant="contained"
            startIcon={<GoogleIcon name="add" size={20} />}
            sx={{ textTransform: 'none', minWidth: 'auto' }}
          >
            <span className="select-add-question">Agregar</span>
          </Button>
        </div>

      </div>

      {Array.isArray(competitionProducts) && competitionProducts.length > 0 && (
        <div className="row">
          <table className="table-pdv table-hover task-product-table">
            <thead className="table-header-gray-task">

              <tr>
                <th className="pl-20">NOMBRE DEL PRODUCTO</th>
                <th>UNIDAD DE VENTA </th>
                <th className="centered">ACCIÓN</th>
              </tr>
            </thead>
            <tbody>
              {competitionProducts.map((product, index) => (
                <tr key={`${product.name}-${index}`}>
                  <td className="pl-20">{product.name}</td>
                  <td>{product.package}</td>
                  <td
                    className="delete-selected-product"
                    onClick={(e) =>
                      setCompetitionProducts(
                        competitionProducts.filter((p) => p.name !== product.name)
                      )
                    }
                  >
                    &times;
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      <div className="task-form-section">
        <TaskScheduleConfig
          isEnabled={isStep5Enabled}
          onScheduleChange={setSchedulePayload}
          onStartChange={handleStartTimeChange}
          onEndChange={handleEndTimeChange}
          isMandatoryTask={isMandatoryTask}
          onMandatoryConflict={handleMandatoryConflict}
          showMandatoryConflict={showMandatoryConflict}
          onDismissMandatoryConflict={handleDismissMandatoryConflict}
        />
      </div>
    </>
  )
}
export default PriceCaptureTask
